import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from 'src/environments/environment';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';

// My Components
import { FirebaseAuthComponent } from './firebase-auth/firebase-auth.component';


// firebase
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';

// material section 
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { MatInputModule } from '@angular/material/input';
import { MatCardModule} from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule} from '@angular/material/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import {MatRadioModule} from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

// bootstrap
import { NgbDatepickerI18n, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { AlertTemplateComponent } from './alert/alert-template.component';
import { MessagesService } from './services/messages/message.service';
import { FilterObservablePipe } from './pipes/pipe-observable.pipe';
import { VerifyAuthService } from './services/guard-auth/verify-auth.service';
import { SendEmailService } from './services/email/send-email.service';
import { CustomDatepickerI18n, I18n } from './config/ng-bootstrap-datepicker-i18n';
import { CaptchaComponent } from './captcha/captcha.component';
import { NgxCaptchaModule } from 'ngx-captcha';


@NgModule({
  declarations: [FirebaseAuthComponent, AlertTemplateComponent, FilterObservablePipe, CaptchaComponent],
  entryComponents: [AlertTemplateComponent],
  imports: [
    CommonModule,
    AngularFireModule,
    AngularFireAuthModule,
    AngularFireModule.initializeApp(environment.firebase),
    FormsModule,
    BrowserAnimationsModule,
    MatInputModule,
    ReactiveFormsModule,
    MatCardModule,
    MatGridListModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMomentDateModule,
    NgbModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    NgxCaptchaModule
  ],
  exports: [
    FirebaseAuthComponent,
    FormsModule,
    BrowserAnimationsModule,
    MatInputModule,
    ReactiveFormsModule,
    MatCardModule,
    MatGridListModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    NgbModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    FilterObservablePipe
  ],
  providers: [FirebaseAuthComponent, MessagesService, VerifyAuthService, SendEmailService, I18n,
    {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {hashBackdrop: false} },
    {provide: LOCALE_ID, useValue: 'de-DE'},
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }]
})
export class SharedModule { }
